import { Component } from '@angular/core';

@Component({
  selector: 'nec-footer-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./copyright.component.scss']
})
export class NecDisclaimerComponent {
}
